import _ from 'lodash';
import { StatusColor, StatusLabels } from '@/utils/constants/testRun';

const convertStatus = (status: string): string => {
  return status.toLowerCase();
};

export const useStatusTestRunData = (
  statusData: Record<string, number>,
) => {
  const statusKey = Object.keys(statusData)
  const labels = statusKey.map(convertStatus);
  const chartDatasets = statusKey.map(label =>
    _.get(statusData, `${label}`, 0),
  );
  const totalStatus = Object.values(statusData).reduce(
    (sum, value) => sum + value,
    0,
  );
 
  const labelColorPairs = labels.map((label) => ({
    label: StatusLabels[label],
    color: StatusColor[label],
  }));

  return {
    statusChartData: {
      labels: labels.map(label => StatusLabels[label]),
      datasets: [
        {
          data: chartDatasets,
          backgroundColor: labels.map(label => StatusColor[label]),
        },
      ],
    },
    totalStatus,
    labelColorPairs,
  };
};
